import { GameBackside, GameHolder } from '@pascal/pascal-core/table-line';
import GameContent from '../../conatiners/gameContent';

export function WebGameMain({ isReplay }) {
  return (
    <GameHolder>
      <GameBackside />
      <GameContent isReplay={isReplay} />
    </GameHolder>
  );
}
